import React, { useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import Input from "components/Input";
import ModalGeneralFailed from "screens/ModalGeneralFailed";
import { useMutation } from "@apollo/client";
import { UPDATE_STAFF_PIN } from "graphql/service";
import { Head, Container, Footer } from "./styles";

const ModalChangePIN = ({
  hidden,
  buttonStyle,
  staffId
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [currentPINEntered, setCurrentPINEntered] = useState(false);
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [currentPIN, setCurrentPIN] = useState("");
  const [newPIN, setNewPIN] = useState("");
  const [PINError, setPINError] = useState(false);

  const [updateStaffPIN, { loading, error }] = useMutation(UPDATE_STAFF_PIN, {
    onCompleted: (data) => {
      setIsOpen(false);
      setFailedIsOpen(false);
      setCurrentPIN("");
      setNewPIN("");
    },
    onError: (error) => {
      setIsOpen(false);
      setFailedIsOpen(true);
    }
  });

  const handleContinue = () => {
    if (currentPIN.trim() === "" || currentPIN.length !== 6) {
      setPINError(true);
      return;
    }
    setCurrentPINEntered(true);
  };

  const handleChangePIN = () => {
    if (loading) return;
    if (newPIN.trim() === "" || newPIN.length !== 6) {
      setPINError(true);
      return;
    }
    updateStaffPIN({
      variables: {
        staffId: staffId, 
        input: {
          currentPin: currentPIN,
          pin: newPIN
        }
      }
    });
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Change PIN"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>
          {currentPINEntered ? "Enter New PIN" : "Enter Current PIN"}
        </Head>
        <Container>
          {currentPINEntered? <Input
            title="6-DIGIT PIN"
            required
            maxLength={6}
            error={PINError}
            errorMessage="Please enter a valid PIN"
            value={newPIN}
            onChange={(e) => {
              const result = e.target.value.replace(/\D/g, "");
              setNewPIN(result);
              setPINError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />: <Input
            title="6-DIGIT PIN"
            required
            maxLength={6}
            error={PINError}
            errorMessage="Please enter a valid PIN"
            value={currentPIN}
            onChange={(e) => {
              const result = e.target.value.replace(/\D/g, "");
              setCurrentPIN(result);
              setPINError(false);
            }}
            additionalstyle={`
            width: 100%;
          `}
          />}
        </Container>
        <Footer>
          <Button
            success
            additionalstyle={`
              width: 97px;
            `}
            onClick={currentPINEntered ? handleChangePIN : handleContinue}
            data-loading={loading}
          >
            {loading ? null : "Continue"}
          </Button>
        </Footer>
      </MainModal>
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setClose={()=> {
          setCurrentPIN("");
          setNewPIN("");
          setCurrentPINEntered(false);
          setFailedIsOpen(false);
        }}
        loading={loading}
        errorMessage={error?.message || "Failed to change PIN. Please try again."}
        retryFunction={handleChangePIN}
        type="changePIN"
      />
    </>
  );
};

export default ModalChangePIN;